import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { LogOut, User } from 'react-feather';
import { useHistory } from 'react-router';
import { translate } from 'react-switch-lang';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import man from '../../assets/images/dashboard/profile.jpg';
import AgrisudLogo from '../../assets/images/logo/logo-agrisud-cropped2.jpg';
import { Role } from '../../models/roleDto';
import Translate from '../translate/translate';
import styles from './rightbar.module.scss';

const Rightbar = (props) => {
  const [name, setName] = useState('');
  const [mainRole, setMainRole] = useState();
  const [setMoonlight] = useState(false);
  const keycloak = useKeycloak().keycloak;
  const history = useHistory();

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const redirectHome = () => {
    history.push('/');
  };

  useEffect(() => {
    setName(localStorage.getItem('Name'));
    if (localStorage.getItem('layout_version') === 'dark-only') {
      setMoonlight(true);
    }
    if (keycloak.authenticated) {
      keycloak.loadUserInfo().then((info) => {
        setName(info.name);
        setMainRole(
          keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
            ? Role.ROLE_AGRISED_ADMIN
            : keycloak.hasResourceRole('ROLE_AGRISED_USER')
            ? Role.ROLE_AGRISED_USER
            : Role.ROLE_AGRISED_ADMIN_SUPER
        );
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles['agrisud-navbar']}>
      {' '}
      {window.outerWidth <= 992 && (
        <div className={styles['agrisud-nav-menus-logo']}>
          <a href="https://agrisud.int.norsys-afrique.ma/web/" target="_blank" rel="noreferrer">
            <img className={styles['nav-image']} src={AgrisudLogo} alt="" />
          </a>{' '}
        </div>
      )}
      <div className={`nav-right ${styles['agrisud-navbar-items']} right-header`}>
        <ul className={`${styles['agrisud-nav-menus']} nav-menus`}>
          <li className="language-nav">
            <Translate />
          </li>{' '}
          {keycloak.authenticated && window.outerWidth > 922 && (
            <li className="profile-nav onhover-dropdown p-0">
              <div className={`${styles['custom-media']} media profile-media`}>
                <img className="b-r-10" src={man} alt="" />
                <div className="media-body">
                  <span> {keycloak.authenticated ? name : 'name'} </span>{' '}
                  <p className="mb-0 font-roboto">
                    {' '}
                    {props.t(mainRole + '')} <i className="middle fa fa-angle-down"> </i>{' '}
                  </p>{' '}
                </div>{' '}
              </div>
              <ul className="profile-dropdown onhover-show-div">
                <li
                  onClick={() => {
                    window.open(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`, '_blank');
                  }}
                >
                  <User />
                  <span> {props.t('auth_profile')} </span>{' '}
                </li>{' '}
                <li
                  onClick={() => {
                    history.push('/');
                    keycloak.logout();
                  }}
                >
                  <LogOut />
                  <span> {props.t('auth_logout')} </span>{' '}
                </li>{' '}
              </ul>{' '}
            </li>
          )}{' '}
        </ul>
        <div className={styles['agrisud-navbar-links']}>
          <div onClick={redirectHome} className={styles['agrisud-admin-navbar-links-slugan']}>
            <h5 className={styles['agrisud-navbar-slugan']}> Agrised </h5>
          </div>{' '}
          {window.outerWidth > 992 ? (
            <div className={styles['agrisud-navbar-links-items']}>
              <div className={styles['agrisud-navbar-links-item']}>
                <a href="https://agrisud.int.norsys-afrique.ma/web/" target="_blank" rel="noreferrer">
                  <span> Agrisud.org </span>{' '}
                </a>{' '}
              </div>{' '}
              <div>
                <span className={styles['agrisud-navbar-aide']} onClick={toggle}>
                  {props.t('Help')}{' '}
                </span>{' '}
              </div>{' '}
            </div>
          ) : (
            <>
              <input className={styles['toggle-menu']} id="toggle-menu" type="checkbox" />
              <nav className={styles['nav-vertical-menu']}>
                <ul>
                  <li onClick={() => history.push('/project/list')}>
                    <span>{props.t('list_projects')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/activity')}>
                    <span>{props.t('list_activities')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/sub-activity')}>
                    <span>{props.t('sub_activity_url')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/production')}>
                    <span>{props.t('list_productivity')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/unit')}>
                    <span>{props.t('reference_units')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/nature-charge')}>
                    <span>{props.t('activity_charge_url')} </span>
                  </li>
                  <li onClick={() => history.push('/settings/nature-product')}>
                    <span>{props.t('list_np')} </span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <a href="https://agrisud.int.norsys-afrique.ma/web/" target="_blank" rel="noreferrer">
                      Agrisud.org{' '}
                    </a>
                  </li>
                  <li>
                    <span onClick={toggle}> {props.t('Help')} </span>{' '}
                  </li>
                  <li
                    onClick={() =>
                      (window.location = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`)
                    }
                  >
                    <User />
                    <span className="m-l-5"> {props.t('auth_profile')} </span>
                  </li>
                  <li
                    onClick={() => {
                      history.push('/');
                      keycloak.logout();
                    }}
                  >
                    <LogOut />
                    <span className="m-l-5"> {props.t('auth_logout')} </span>{' '}
                  </li>
                </ul>{' '}
              </nav>
              <label className={styles['button-toggle-menu']} htmlFor="toggle-menu">
                <i className="fa fa-bars"> </i>{' '}
              </label>
              <label className={styles['overlay']} htmlFor="toggle-menu">
                {' '}
              </label>
            </>
          )}{' '}
        </div>
      </div>
      <Modal className={styles['modal-aide']} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}> {props.t('Help')} </ModalHeader>{' '}
        <ModalBody>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
          laborum.
        </ModalBody>{' '}
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Fermer{' '}
          </Button>{' '}
        </ModalFooter>
      </Modal>{' '}
    </div>
  );
};
export default translate(Rightbar);
